<template>
  <div>
    <v-card>
      <v-card-title>
        <span class="headline">Catálogo</span>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12 sm12 lg12 d-flex>
              <v-text-field label="Artículo" v-model="registro.catalogoArticulo" :messages="errores.catalogoArticulo.mensajes" :error="errores.catalogoArticulo.error" v-bind:readonly="disabledRegistro" v-on:keyup="registro.catalogoArticulo = registro.catalogoArticulo.toUpperCase();"></v-text-field>
            </v-flex>
            <v-layout wrap>
              <v-flex xs12 sm5 lg4 d-flex>
                <v-text-field label="Unidad" v-model="registro.catalogoUnidad" :messages="errores.catalogoUnidad.mensajes" :error="errores.catalogoUnidad.error" v-bind:readonly="disabledRegistro"></v-text-field>
              </v-flex>
              <v-flex xs12 sm5 lg4 d-flex>
                <v-text-field label="Marca" v-model="registro.catalogoMarca" :messages="errores.catalogoMarca.mensajes" :error="errores.catalogoMarca.error" v-bind:readonly="disabledRegistro" v-on:keyup="registro.catalogoMarca = registro.catalogoMarca.toUpperCase();"></v-text-field>
              </v-flex>
              <v-flex xs12 sm5 lg4 d-flex>
                <v-text-field label="Modelo" v-model="registro.catalogoModelo" :messages="errores.catalogoModelo.mensajes" :error="errores.catalogoModelo.error" v-bind:readonly="disabledRegistro" v-on:keyup="registro.catalogoModelo = registro.catalogoModelo.toUpperCase();"></v-text-field>
              </v-flex>
            </v-layout>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="success" dark @click.native="guardar(registro.catalogoId)" v-if="!disabledRegistro">Guardar</v-btn>
        <v-btn color="primary" dark @click.native="editar" v-if="disabledRegistro">Editar</v-btn>
        <v-btn color="primary" dark @click.native="cerrar">Cerrar</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import mixin from '../mixins.js'
export default {
  mixins: [mixin],
  name: 'catalogo',
  props: {
    idRegistro: 0,
    ubigeo: {}
  },
  data: () => ({
    disabledRegistro: false,
    loading: false,
    datos: [],
    registro: {},
    errores: {
      'catalogoArticulo': {mensajes: [], error: false},
      'catalogoUnidad': {mensajes: [], error: false},
      'catalogoModelo': {mensajes: [], error: false},
      'catalogoMarca': {mensajes: [], error: false}
    }
  }),
  created () {
    this.initialize()
  },
  watch: {
    idRegistro () {
      if (this.idRegistro !== '') {
        this.ver({id: this.idRegistro})
      }
    }
  },
  methods: {
    initialize () {
      this.datos = {}
    },
    ver (item) {
      var solicitudApi = this.crearSolicitud()
      solicitudApi.datos = []
      const myRequest = new Request(`${process.env.NODE_API}catalogo/ver/id/` + item.id, {method: 'POST', body: `d=${JSON.stringify(solicitudApi)}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
      return fetch(
        myRequest
      )
        .then(response => response.json())
        .then(datos => {
          if (datos.l === false) {
            this.$emit('login', datos.m)
          } else {
            this.registro = datos.d.catalogo
            this.errores = datos.d.errores
            if (item.id === 0) {
              this.registro.catalogoId = 0
              this.disabledRegistro = false
            } else {
              this.disabledRegistro = true
            }
          }
        })
    },
    guardar (id) {
      var solicitudApi = this.crearSolicitud()
      solicitudApi.datos = this.registro
      const myRequest = new Request(`${process.env.NODE_API}catalogo/guardar/id/` + id, {method: 'POST', body: `d=${JSON.stringify(solicitudApi)}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
      return fetch(
        myRequest
      )
        .then(response => response.json())
        .then(datos => {
          if (datos.l === false) {
            this.$emit('login', datos.m)
          } else {
            if (datos.e === 1) {
              this.ver(datos.d)
              this.$emit('listar')
            } else {
              this.errores = datos.d.errores
            }
          }
        })
    },
    editar () {
      this.disabledRegistro = false
    },
    cerrar () {
      this.$emit('cerrar')
    }
  }
}
</script>

<style>
.v-btn--floating .v-icon {
    height: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Catalogo.vue